module.exports = __webpack_public_path__ + "img/auth_loading.244f51d0.gif";